import React from 'react';
import { useConnect } from '@lore/query-connect';
import REQUIRED_FIELDS from '../../projects/REQUIRED_FIELDS';
import { PayloadStates } from '@lore/utils';
import MetricLoader from '../MetricLoader';
import DeltaMetric from '../DeltaMetric';
import { site_state_$ilike } from '../../../utils/query-helpers';

export default function StudentsYear(props) {
  const { state, network, schoolStart, schoolEnd, titleOnly } = props;

  const allProjects = useConnect('project.find', {
    where: {
      eager: {
        $where: {
          $and: REQUIRED_FIELDS.$and,
          // networkId: network?.id,
          ...site_state_$ilike(state),
          completed: true,
          students: {
            $gte: 0
          },
          createdAt: {
            $lte: schoolEnd
          }
        }
      }
    },
    pagination: {
      pageSize: 1000
    }
  });

  const newProjects = useConnect('project.find', {
    where: {
      eager: {
        $where: {
          $and: REQUIRED_FIELDS.$and,
          // networkId: network?.id,
          ...site_state_$ilike(state),
          completed: true,
          students: {
            $gte: 0
          },
          createdAt: {
            $lte: schoolEnd,
            $gte: schoolStart
          }
        }
      }
    },
    pagination: {
      pageSize: 1000
    }
  });

  if (
    allProjects.state === PayloadStates.FETCHING ||
    newProjects.state === PayloadStates.FETCHING
  ) {
    return (
      <MetricLoader
        name="Students Impacted"
      />
    );
  }

  const totalCount = _.reduce(allProjects.data, function(result, project) {
    return result + project.data.students;
  }, 0);

  const newCount = _.reduce(newProjects.data, function(result, project) {
    return result + project.data.students;
  }, 0);

  return (
    <DeltaMetric
      name="Students Impacted"
      value={totalCount}
      delta={newCount}
      titleOnly={titleOnly}
    />
  );
}
